import React, { useState, useMemo } from 'react';
import CardActualizacionMasiva from "../../../General/Excel/CardActualizacionMasiva";
import {
  leerExcelPublicaciones,
  leerExcelPublicacionesPorCodigo,
  postExcelPublicaciones,
  postExcelPublicacionesModerador
} from '../../../../api/axios';
import { toast } from 'react-toastify';

export default function ActualizacionMasivaPrecioYStock({ idSeller, userType, idUsuario }) {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxesSeller, setCheckboxesSeller] = useState({
    stock: false,
    precioLista: false,
    precioPromocional: false,
  });
  const optionsCheckboxes = useMemo(() => {
    return [
      { label: "Precio Lista", name: "precioLista" },
      { label: "Precio Promocional", name: "precioPromocional" },
      { label: "Stock", name: "stock" },
    ];
  }, []);

  const isValidUpdateExcel = () => {
    if (!file) {
      toast.warn("No se ha seleccionado ningún archivo excel");
      return false;
    }

    if (userType.isSellerAdmin || userType.isSeller) {
      const { stock, precioLista, precioPromocional } = checkboxesSeller;
      if (!stock && !precioLista && !precioPromocional) {
        toast.warn("Debe seleccionar al menos una opción de importación");
        return false;
      }
    };
    return true;
  }

  const exportExcel = () => {
    setIsLoading(true);

    var oData = new FormData();
    oData.append("filename", file.name);
    oData.append("filedata", file);

    if (userType.isSellerAdmin || userType.isSeller) {

      const { stock, precioLista, precioPromocional } = checkboxesSeller;
      oData.append("idSeller", idSeller);
      oData.append("ch_stock", stock);
      oData.append("ch_precioLista", precioLista);
      oData.append("ch_precioPromocional", precioPromocional);

      let req = leerExcelPublicaciones(oData);

      req.then(res1 => {

        if (res1.data == "Archivo con formato incorrecto") {
          toast.error(res1.data);
          return;
        }

        if (res1.data.error == "no se importo") toast.error(res1.data.mensaje + " " + res1.data.skuSellerFallo);
        if (res1.data.error == "") toast.success(res1.data.mensaje);
        if (res1.data.fallaronTodos) return;

        let post = postExcelPublicaciones(res1.data.listaExcel, idUsuario);
        post.then(res => {
          try {
            if (res.data.errores.length == 0) {
              toast.success("Publicaciones actualizadas");
            }
          } catch (e) {
            if (res.data[0] != null) {
              let errors = res.data.join(', ');
              toast.error(errors);
            }
          }
        }).catch(error => {
          toast.error("Error al guardar " + error)
        });
      }).catch(error => {
        toast.error("Error al leer archivo")
      }).finally(() => {
        setIsLoading(false);
      });
    } else {
      let req = leerExcelPublicacionesPorCodigo(oData);
      req.then(res1 => {

        if (res1.data == "Archivo con formato incorrecto") {
          toast.error(res1.data);
          return;
        }

        if (res1.data.error == "no se importo") toast.error(res1.data.mensaje + " " + res1.data.skuSellerFallo);
        if (res1.data.error == "") toast.success(res1.data.mensaje);
        if (res1.data.fallaronTodos) return;

        let post = postExcelPublicacionesModerador({ listaElementos: res1.data.listaExcel });
        post.then(res => {
          try {
            if (res.data.errores.length == 0) toast.success("Publicaciones actualizadas");
          } catch (e) {
            if (res.data[0] != null) {
              let errors = res.data.join(', ');
              toast.error(errors);
            }
          }
        }).catch(error => {
          toast.error("Error al guardar " + error)
        }).finally(() => {
          setIsLoading(false);
        });
      }).catch(error => {
        toast.error("Error al leer archivo")
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }

  const toggleCheckbox = (checkboxName) => {
    setCheckboxesSeller({
      ...checkboxesSeller,
      [checkboxName]: !checkboxesSeller[checkboxName],
    });
  };

  const excelTemplate = {
    fileResultName: "Modelo Actualización Precio-Stock",
    sheetName: "Publicaciones",
    columns: (userType.isSellerAdmin || userType.isSeller) ?
      [{ "SKU Seller": "0", "Precio Lista": "0", "Precio Oferta": "0", "Stock": "0", }] :
      [{ "SKU Megatone": "0", "Precio Lista": "0", "Mega Oferta": "0" }]
  };


  return (
    <div className="card p-4">
      <CardActualizacionMasiva
        title="Precios y Stock"
        btnText="Actualizar Publicaciones"
        dataSet={excelTemplate}
        updateFile={setFile}
        isLoading={isLoading}
        exportExcel={exportExcel}
        isValidUpdateExcel={isValidUpdateExcel}
      >
        <div className="col-12" hidden={userType.isAdminMod}>
          <label><strong>Seleccionar opciones de importación:</strong></label>
          {optionsCheckboxes.map((option, i) => (
            <div className="col-auto" key={i}>
              <input
                type="checkbox"
                className="big-checkbox mx-2"
                checked={checkboxesSeller[option.name]}
                onChange={() => toggleCheckbox(option.name)}
              />
              {option.label}
            </div>
          ))}
        </div>
      </CardActualizacionMasiva>
    </div>
  );
}